import React from 'react';
import { Box, CircularProgress, Typography, Container } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading...", 
  size = 60 
}) => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress size={size} />
        <Typography variant="h6" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Container>
  );
};

export default LoadingSpinner;